module.exports = __webpack_public_path__ + "static/media/featured-1-bed-en.cac16c42.png";